import React from 'react'
import useQueryGetUserSidebar from '@hook/query/portfolio/useQueryGetUserSidebar'
import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'

import Text from '@component/Text/Text'
import UserThumbnail from '@component/images/UserThumbnail'
import MobileUserScoreComponent from '@feature/portfolio/components/MobileUserProfileHeader/components/MobileUserScoreComponent'
import MobileUserProfileSkeleton from '@feature/portfolio/components/MobileUserProfileHeader/skeletons/MobileUserProfileSkeleton'
import PayToSeeTag from '@feature/portfolio/components/MobileUserProfileHeader/components/PayToSeeTag'

import ProBadgeIcon from '@svg/pro/ic_header_pro_badge.svg'

interface IProps {
    className?: string
    id?: string
    login_id?: string
    isPaidfolio?: boolean
}

const MobileUserProfile = ({className, id, login_id, isPaidfolio}: IProps) => {
    const {data: me} = useQueryFetchMe(undefined, false)
    const {data: sidebar, isLoading} = useQueryGetUserSidebar(id)

    if (isLoading) {
        return <MobileUserProfileSkeleton />
    }

    return (
        <div className={`space-y-[10px] ${className}`}>
            <div className={'flex items-center gap-x-[5px]'}>
                {isPaidfolio && <PayToSeeTag />}
                <div className={'flex items-center gap-x-[3px]'}>
                    <Text className={'text-btn text-gray01 dark:text-dark_gray01'}>{sidebar?.username}</Text>
                    {sidebar?.is_pro && <ProBadgeIcon className={'w-[18px] h-[18px]'} />}
                </div>
            </div>

            <div className={'flex items-center gap-x-[7px]'}>
                <UserThumbnail
                    src={sidebar?.thumbnail}
                    size={50}
                    isPro={sidebar?.is_pro}
                    containerClassName={'flex-none'}
                    isMe={me?.id === login_id}
                    network={me?.network}
                />

                {/* 24, 30, all, risk */}
                <MobileUserScoreComponent id={id} login_id={login_id} />
            </div>
        </div>
    )
}
export default MobileUserProfile
